<template>
  <Component
    :is="preventKeepAlive ? 'div' : 'KeepAlive'">
    <Component
      v-bind="stepProps"
      :is="componentToShow"
      @prev-step="prevStep"
      @complete="completeStep"
    />
  </Component>
</template>

<script setup>
import {computed, ref, watch, provide} from "vue";
import {useRouter, onBeforeRouteUpdate} from "vue-router";

const emits = defineEmits(["update:step", "complete"]);
const props = defineProps({
  stepList: Array,
  recycleSteps: Boolean,
  warnOnLeave: Boolean,
  trackHistory: Boolean,
  isOutsideRouter: Boolean,
  preventKeepAlive: Boolean,
  stepProps: Object,
});

const router = useRouter();

const currentStep = ref(0);
const componentToShow = computed(() => props.stepList[currentStep.value]);

provide("currentStep", currentStep);

const completeStep = (stepCount = 1) => {
  // Handle Scroll Top
  scrollToTop();

  // Handle Step Completion
  if (isLastStep.value || currentStep.value + stepCount >= props.stepList.length) {
    if (props.recycleSteps) currentStep.value = 0;
    else emits("complete");
    return;
  }

  // Handle Next Step
  if (currentStep.value < props.stepList.length - 1) nextStep(stepCount);
};

const nextStep = (stepCount) => {
  (currentStep.value += stepCount);
  window.scrollTo(0, 0);
  if (props.trackHistory) router.push({ query: { ...router.currentRoute.value.query, s: currentStep.value } });
};

const prevStep = (stepBackCount = 1) => {
  if (currentStep.value - stepBackCount >= 0)
    currentStep.value -= stepBackCount;
  else currentStep.value = 0;
  window.scrollTo(0, 0);
};

if (!props.isOutsideRouter) {
  onBeforeRouteUpdate((to, from, next) => {
    if (to.path !== from.path || !props.trackHistory) return next();

    const stepNumber = to.query.s || "0";
    const stepNumberInt = parseInt(stepNumber);

    if (stepNumberInt >= 0 && stepNumberInt < props.stepList.length) {
      currentStep.value = stepNumberInt;
    }

    next();
  });
}

const isLastStep = computed(() => {
  return currentStep.value === props.stepList.length - 1;
});

const scrollToTop = () => {
  let overflows = document.getElementsByClassName("overflow-y-auto");
  let modalOverflow = document.getElementsByClassName("max-h-modal");
  for (let i = 0; i < overflows.length; i++) overflows[i].scrollTop = 0;
  for (let i = 0; i < modalOverflow.length; i++) modalOverflow[i].scrollTop = 0;
  let stepItem = document.getElementById("stepItemSection");
  if (stepItem) stepItem.scrollTop = 0;
  document.body.scrollTop = 0;
};

watch(() => currentStep.value, (newValue, oldValue) => {
  if (newValue === oldValue) return;
  emits("update:step", newValue);
});

defineExpose({
  nextStep,
  prevStep,
});
</script>
